import Order from "../../../models/order/order.model";
import NewPrices from "../../../models/order/newPrices.model";
import roundAbnt from "../../formaters/roundAbnt";

const tableChangeCalculations = (order: Order, newPrices: NewPrices[]) => {
  order.itens.forEach((item) => {
    let newPrice = newPrices.filter(
      (productPrice) => productPrice.id === item.produtoId
    );
    if (newPrice.length > 0 && newPrice[0].newPrice) {
      const newItemTotal = roundAbnt(
        newPrice[0].newPrice.preco * item.quantidade
      );
      const newItemIpi = roundAbnt(
        Math.round(newPrice[0].newPrice.preco * item.percentualIpi * 100) / 100
      );

      item.unitario = newPrice[0].newPrice.preco;
      item.unitarioFinal = newPrice[0].newPrice.preco;
      item.valorIpi = newItemIpi;
      item.totais.acrescimos.total = 0;
      item.totais.acrescimos.item.percentual = 0;
      item.totais.acrescimos.item.valor = 0;
      item.totais.acrescimos.item.total = 0;
      item.totais.descontos.total = 0;
      item.totais.descontos.item.percentual = 0;
      item.totais.descontos.item.valor = 0;
      item.totais.descontos.item.total = 0;
      item.totais.total = newItemTotal;
      item.totais.produtos = newItemTotal;
    } else {
      const newItemTotal = roundAbnt(item.unitario * item.quantidade);

      item.totais.acrescimos.total = 0;
      item.totais.acrescimos.item.percentual = 0;
      item.totais.acrescimos.item.valor = 0;
      item.totais.acrescimos.item.total = 0;
      item.totais.descontos.total = 0;
      item.totais.descontos.item.percentual = 0;
      item.totais.descontos.item.valor = 0;
      item.totais.descontos.item.total = 0;
      item.totais.total = newItemTotal;
      item.totais.produtos = newItemTotal;
    }
    return item;
  });

  const newOrderTotal = order.itens.reduce((acc, currValue) => {
    return acc + currValue.totais.produtos;
  }, 0);

  const newOrderTotalIpi = order.itens.reduce((acc, currValue) => {
    return acc + currValue.valorIpi * currValue.quantidade;
  }, 0);

  order.totais.produtos = roundAbnt(newOrderTotal);
  order.totais.totalIpi = roundAbnt(newOrderTotalIpi);
  order.totais.total = roundAbnt(newOrderTotal);
  order.totais.acrescimos.cabecalho.percentual = 0;
  order.totais.acrescimos.cabecalho.valor = 0;
  order.totais.acrescimos.cabecalho.total = 0;
  order.totais.acrescimos.itens.total = 0;
  order.totais.acrescimos.total = 0;
  order.totais.descontos.cabecalho.percentual = 0;
  order.totais.descontos.cabecalho.valor = 0;
  order.totais.descontos.cabecalho.total = 0;
  order.totais.descontos.itens.total = 0;
  order.totais.descontos.total = 0;

  return order;
};

export default tableChangeCalculations;
